// DEV-ONLY paywall preview switch.
//
// Local `.env` points at the production database, so flipping the real
// `tierGatingEnabled` AppSettings flag to "see the blur locally" would turn the
// paywall on for real users. This composable instead lets us preview the
// free-user blur/teaser/CTA locally without touching any flag or DB:
//
//   /dashboard?paywall=preview   → force the paywall ON  (sticks everywhere)
//   /dashboard?paywall=off       → force it OFF
//
// It is honored ONLY under `import.meta.dev`, so it can never change behavior in
// production. The intent is latched into localStorage the instant we see the
// query, because some pages (e.g. /explore) rewrite their own URL query on load
// and would otherwise drop the flag. Once set it persists across pages, reloads
// and tabs until `?paywall=off`. A shared useState keeps every page reactive.
const KEY = 'paywallPreview';

export const usePaywallPreview = () => {
  const route = useRoute();
  const state = useState<boolean>('paywallPreview', () => false);

  const sync = (raw: unknown) => {
    if (!import.meta.dev || !import.meta.client) return;
    if (raw === 'preview' || raw === '1') {
      state.value = true;
      localStorage.setItem(KEY, '1');
    } else if (raw === 'off' || raw === '0') {
      state.value = false;
      localStorage.removeItem(KEY);
    }
  };

  if (import.meta.dev && import.meta.client) {
    // Latch from a persisted preview first, then let the current/next query win.
    if (localStorage.getItem(KEY) === '1') state.value = true;
    watch(() => route.query.paywall, sync, { immediate: true });
  }

  const previewPaywall = computed(() => import.meta.dev && state.value);
  return { previewPaywall };
};
